import * as Styled from '../../styled'
import { Skeleton } from '~components'

const ConsumptionCardSkeleton = () => (
  <>
    <Styled.ConsumptionLoader>
      <Skeleton $width="50%" $height="20px" isLoading={true} />
      <Skeleton $width="20%" $height="20px" isLoading={true} />
    </Styled.ConsumptionLoader>

    <Styled.ConsumptionLoader>
      <Skeleton $width="50%" $height="20px" isLoading={true} />
      <Skeleton $width="20%" $height="20px" isLoading={true} />
    </Styled.ConsumptionLoader>

    <Styled.ConsumptionLoader>
      <Skeleton $width="100%" $height="100px" isLoading={true} />
    </Styled.ConsumptionLoader>
  </>
)

export default ConsumptionCardSkeleton
